import { getToken, onMessage } from 'firebase/messaging';
import { useEffect, useRef } from 'react';
import { localStorageKeys } from '../constants';
import { messaging, VAPID_KEY } from '../config/firebase';
import { apiClient } from '../services/apiSLTP/apiClient';
import { useAuth } from './useAuth';

const useWebPushNotifications = () => {
    const { isAuthenticated, authIsLoading } = useAuth();
    const registered = useRef(false);

    useEffect(() => {
        // Logout avéré (pas juste un refresh pendant le chargement)
        if (!isAuthenticated && !authIsLoading) {
            localStorage.removeItem(localStorageKeys.FCM_WEB_TOKEN);
            registered.current = false;
            return;
        }

        if (!isAuthenticated || registered.current) return;

        const register = async () => {
            try {
                const permission = await Notification.requestPermission();
                if (permission !== 'granted') return;

                const token = await getToken(messaging, { vapidKey: VAPID_KEY });
                if (!token) return;

                const storedToken = localStorage.getItem(localStorageKeys.FCM_WEB_TOKEN);
                if (storedToken === token) {
                    registered.current = true;
                    return;
                }

                await apiClient.post('/notifications/push-token/web', { token });
                localStorage.setItem(localStorageKeys.FCM_WEB_TOKEN, token);
                registered.current = true;
            } catch (error) {
                console.error('[FCM] Error registering token:', error);
            }
        };

        register();
    }, [isAuthenticated, authIsLoading]);

    useEffect(() => {
        const unsubscribe = onMessage(messaging, (payload) => {
            const { title, body } = payload.notification ?? {};
            if (!title) return;
            new Notification(title, { body });
        });
        return unsubscribe;
    }, []);
};

export default useWebPushNotifications;
